import React, { useEffect, useState } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import MainContainer from "../../layout/MainContainer";
import { Box, Button, FormControl, Grid, Paper, styled } from "@mui/material";
import NativeSelect from "@mui/material/NativeSelect";
import { LineChart } from "../../components";
import { useNavigate } from "react-router-dom";
import {
  useLazyPostOrderGraphQuery,
  useLazyPostProductGraphQuery,
  useLazyPostUserGraphQuery,
  useLazyPostVendorGraphQuery,
} from "../../services/dashboard";
import useTranslation from "../../hooks/Translation";
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#204e33" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));
const Analytics = () => {
  const navigate = useNavigate();
  const t = useTranslation();
  const [user, serUser] = useState<any>([]);
  const [revenue, setRevenue] = useState<any>([]);
  const [property, setProperty] = useState<any>([]);
  const [agent, setAgent] = useState<any>([]);
  const [userGraphData, setUserGraphData] = useState<any>([]);
  const [vendorGraphData, setVendorGraphData] = useState<any>([]);
  const [orderGraphData, setOrderGraphData] = useState<any>([]);
  const [productGraphData, setProductGraphData] = useState<any>([]);
  const [userGraphApi] = useLazyPostUserGraphQuery();
  const [vendorGraphApi] = useLazyPostVendorGraphQuery();
  const [orderGraphApi] = useLazyPostOrderGraphQuery();
  const [productGraphApi] = useLazyPostProductGraphQuery();
  // const [company, setCompany] = useState<any>([]);
  const company = [
    { label: "Jan", value: 1200 },
    { label: "Feb", value: 900 },
    { label: "March", value: 1500 },
    { label: "April", value: 700 },
    { label: "May", value: 1100 },
    { label: "June", value: 600 },
    { label: "July", value: 1300 },
    { label: "August", value: 800 },
  ];

  const [selectedType1, setSelectedType1] = useState<string>("1");
  const [selectedType2, setSelectedType2] = useState<string>("1");
  const [selectedType3, setSelectedType3] = useState<string>("1");
  const [selectedType4, setSelectedType4] = useState<string>("1");
  const [selectedType5, setSelectedType5] = useState<string>("1");
  const [selectedType6, setSelectedType6] = useState<string>("1");
  const [selectedType7, setSelectedType7] = useState<string>("1");

  const callUserGraph = async () => {
    try {
      const response = await userGraphApi({
        interval: Number(selectedType1),
      }).unwrap();
      if (response.status === 200) {
        const apiData = response?.data;
        const formattedData = Object.keys(apiData).map((key) => ({
          label: key,
          value: apiData[key],
        }));
        setUserGraphData(formattedData);
      }
    } catch (e) {
      console.error("Error fetching user graph data:", e);
    }
  };

  const callVendorGraph = async () => {
    try {
      const response = await vendorGraphApi({
        interval: Number(selectedType2),
      }).unwrap();
      if (response.status === 200) {
        const apiData = response?.data;
        const formattedData = Object.keys(apiData).map((key) => ({
          label: key,
          value: apiData[key],
        }));
        setVendorGraphData(formattedData);
      }
    } catch (e) {
      console.error("Error fetching user graph data:", e);
    }
  };

  const callOrderGraph = async () => {
    try {
      const response = await orderGraphApi({
        interval: Number(selectedType3),
      }).unwrap();
      if (response.status === 200) {
        const apiData = response?.data;
        const formattedData = Object.keys(apiData).map((key) => ({
          label: key,
          value: apiData[key],
        }));
        setOrderGraphData(formattedData);
      }
    } catch (e) {
      console.error("Error fetching user graph data:", e);
    }
  };

  const callProductGraph = async () => {
    try {
      const response = await productGraphApi({
        interval: Number(selectedType4),
      }).unwrap();
      if (response.status === 200) {
        const apiData = response?.data;
        const formattedData = Object.keys(apiData).map((key) => ({
          label: key,
          value: apiData[key],
        }));
        setProductGraphData(formattedData);
      }
    } catch (e) {
      console.error("Error fetching user graph data:", e);
    }
  };

  const graphUsersData = {
    labels:
      userGraphData.length !== 0
        ? userGraphData?.map((item: any) => item.label)
        : [],
    datasets: [
      {
        label: t.main.totalCustomers,
        data:
          userGraphData.length !== 0
            ? userGraphData?.map((item: any) => item.value)
            : [],
        borderColor: "black",
        backgroundColor: "#AAAAAA",
      },
    ],
  };

  const graphVendorData = {
    labels:
      vendorGraphData?.length !== 0
        ? vendorGraphData?.map((item: any) => item.label)
        : [],
    datasets: [
      {
        label: t.main.totalVendors,
        data:
          vendorGraphData?.length !== 0
            ? vendorGraphData?.map((item: any) => item.value)
            : [],
        borderColor: "black",
        backgroundColor: "#AAAAAA",
      },
    ],
  };

  const graphOrderData = {
    labels:
      orderGraphData?.length !== 0
        ? orderGraphData?.map((item: any) => item.label)
        : [],
    datasets: [
      {
        label: t.main.totalOrders,
        data:
          orderGraphData?.length !== 0
            ? orderGraphData?.map((item: any) => item.value)
            : [],
        borderColor: "black",
        backgroundColor: "#AAAAAA",
      },
    ],
  };

  const graphProductData = {
    labels:
      productGraphData?.length !== 0
        ? productGraphData?.map((item: any) => item.label)
        : [],
    datasets: [
      {
        label: t.main.totalProductsListed,
        data:
          productGraphData?.length !== 0
            ? productGraphData?.map((item: any) => item.value)
            : [],
        borderColor: "black",
        backgroundColor: "#AAAAAA",
      },
    ],
  };

  const graphAgentData = {
    labels: company.length !== 0 ? company?.map((item: any) => item.label) : [],
    datasets: [
      {
        label: "Total Vendors",
        data:
          company.length !== 0 ? company?.map((item: any) => item.value) : [],
        borderColor: "black",
        backgroundColor: "#AAAAAA",
      },
    ],
  };
  const graphCompanyyData = {
    labels: company.length !== 0 ? company?.map((item: any) => item.label) : [],
    datasets: [
      {
        label: "Total Subcategories",
        data:
          company.length !== 0 ? company?.map((item: any) => item.value) : [],
        borderColor: "black",
        backgroundColor: "#AAAAAA",
      },
    ],
  };
  const graphEarningData = {
    labels: company.length !== 0 ? company?.map((item: any) => item.label) : [],
    datasets: [
      {
        label: "Total Earnings",
        data:
          company.length !== 0 ? company?.map((item: any) => item.value) : [],
        borderColor: "black",
        backgroundColor: "#AAAAAA",
      },
    ],
  };
  const graphSalesData = {
    labels: company.length !== 0 ? company?.map((item: any) => item.label) : [],
    datasets: [
      {
        label: "Total Sales",
        data:
          company.length !== 0 ? company?.map((item: any) => item.value) : [],
        borderColor: "black",
        backgroundColor: "#AAAAAA",
      },
    ],
  };
  const graphRevenueData = {
    labels: company?.map((item: any) => item.label),
    datasets: [
      {
        label: "Total Categories",
        data:
          company.length !== 0 ? company?.map((item: any) => item.value) : [],
        borderColor: "black",
        backgroundColor: "#AAAAAA",
      },
    ],
  };

  const handleChange1 = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newType = event.target.value as string;
    setSelectedType1(newType);
  };
  const handleChange2 = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newType = event.target.value as string;
    setSelectedType2(newType);
  };
  const handleChange3 = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newType = event.target.value as string;
    setSelectedType3(newType);
  };
  const handleChange4 = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newType = event.target.value as string;
    setSelectedType4(newType);
  };
  const handleChange5 = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newType = event.target.value as string;
    setSelectedType5(newType);
  };
  const handleChange6 = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newType = event.target.value as string;
    setSelectedType6(newType);
  };
  const handleChange7 = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newType = event.target.value as string;
    setSelectedType7(newType);
  };

  useEffect(() => {
    callUserGraph();
  }, [selectedType1]);
  useEffect(() => {
    callVendorGraph();
  }, [selectedType2]);
  useEffect(() => {
    callOrderGraph();
  }, [selectedType3]);
  useEffect(() => {
    callProductGraph();
  }, [selectedType4]);

  return (
    <div>
      {/* <Loader isLoading={isLoading} /> */}
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">{t.sideBar.analytics}</h1>
        </div>
        <Grid container spacing={2} className="dashGraph">
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <Item className="cards dashGraph_item">
              <h2 className="mn_hdng">
                {t.main.totalCustomers}
                <FormControl>
                  <div>
                    {/* <Button sx={{margin:"5px"}}className="btn btn_primary" onClick={handleExportUserCsv}>
                <FileDownloadIcon /> Export CSV
              </Button> */}
                    <NativeSelect
                      defaultValue={selectedType1}
                      onChange={handleChange1}
                      inputProps={{
                        name: "report",
                        id: "uncontrolled-native",
                      }}
                    >
                      <option value="1">{t.main.daily}</option>
                      <option value="2">{t.main.weekly}</option>
                      <option value="3">{t.main.monthly}</option>
                      <option value="4">{t.main.yearly}</option>
                    </NativeSelect>
                  </div>
                </FormControl>
              </h2>
              <LineChart data={graphUsersData} />
            </Item>
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <Item className="cards dashGraph_item">
              <h2 className="mn_hdng">
                {t.main.totalVendors}
                <FormControl>
                  <div>
                    <NativeSelect
                      defaultValue={selectedType2}
                      onChange={handleChange2}
                      inputProps={{
                        name: "report",
                        id: "uncontrolled-native",
                      }}
                    >
                      <option value="1">{t.main.daily}</option>
                      <option value="2">{t.main.weekly}</option>
                      <option value="3">{t.main.monthly}</option>
                      <option value="4">{t.main.yearly}</option>
                    </NativeSelect>
                  </div>
                </FormControl>
              </h2>
              <LineChart data={graphVendorData} />
            </Item>
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <Item className="cards dashGraph_item">
              <h2 className="mn_hdng">
                {t.main.totalOrders}
                <FormControl>
                  <div>
                    {/* <Button sx={{margin:"5px"}}className="btn btn_primary" onClick={handleExportUserCsv}>
                <FileDownloadIcon /> Export CSV
              </Button> */}
                    <NativeSelect
                      defaultValue={selectedType3}
                      onChange={handleChange3}
                      inputProps={{
                        name: "report",
                        id: "uncontrolled-native",
                      }}
                    >
                      <option value="1">{t.main.daily}</option>
                      <option value="2">{t.main.weekly}</option>
                      <option value="3">{t.main.monthly}</option>
                      <option value="4">{t.main.yearly}</option>
                    </NativeSelect>
                  </div>
                </FormControl>
              </h2>
              <LineChart data={graphOrderData} />
            </Item>
          </Grid>

          {/* total companies */}
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <Item className="cards dashGraph_item">
              <h2 className="mn_hdng">
                {t.main.totalProductsListed}
                <FormControl>
                  <div>
                    <NativeSelect
                      defaultValue={selectedType4}
                      onChange={handleChange4}
                      inputProps={{
                        name: "report",
                        id: "uncontrolled-native",
                      }}
                    >
                      <option value="1">{t.main.daily}</option>
                      <option value="2">{t.main.weekly}</option>
                      <option value="3">{t.main.monthly}</option>
                      <option value="4">{t.main.yearly}</option>
                    </NativeSelect>
                  </div>
                </FormControl>
              </h2>
              <LineChart data={graphProductData} />
            </Item>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default Analytics;
